import type { GlucoseAverageReadingBedtimeInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { BedtimeFillIcon } from "@tandemdiabetes/sugarmate-react-components"
import { useCalculationsContext } from "../CalculationsContext"
import styles from "./Tile.module.scss"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import {
  useDisplayGlucoseValue,
  useReadableGlucoseUnit,
} from "src/hooks"

export function GlucoseAverageReadingBedtime(props: TileProps<GlucoseAverageReadingBedtimeInsight>) {
  const {
    insightKey,
    range,
  } = props

  const displayGlucoseValue = useDisplayGlucoseValue()
  const glucoseUnit = useReadableGlucoseUnit()

  const { glucoseCalculations } = useCalculationsContext()
  const { bedTimeAverage } = glucoseCalculations[range] || {}

  const value = (isNaN(bedTimeAverage) || bedTimeAverage === undefined)
    ? "--"
    : displayGlucoseValue(bedTimeAverage)

  return (
    <>
      <TileTitle insightKey={insightKey}>
        <BedtimeFillIcon className={styles.titleIcon} />
      </TileTitle>
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {value}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {glucoseUnit}
      </TileUnit>
    </>
  )
}
